import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import useAppState from "context/useAppState";

const ColumnBarChart = () => {

  const {
    setState,
    downloadChart,
    downloadChartName,
    chartName
  } = useAppState("eventData");

  const chartRef = React.useRef<any>(null);

  useEffect(() => {
    if (downloadChart) {
      downloadAsSVG()
      setState({ downloadChart: false })
    }
  }, [downloadChart])

  const downloadAsSVG = async () => {
    if (chartRef.current && chartName == 'column_bar_chart') {
      try {
        await chartRef.current.chart.exports.exportToSVG(); // Use getSVGString for SVG data
      } catch (error) {
        console.error("Error downloading chart:", error);
      }
    }
  };

  // Sample data for the column chart
  const series = [
    {
      name: "Net Profit",
      data: [44, 55, 57, 56, 61, 58, 63],
    },
    {
      name: "Revenue",
      data: [76, 85, 101, 98, 87, 105, 91],
    },
    {
      name: "Free Cash Flow",
      data: [35, 41, 36, 26, 45, 48, 52],
    },
    {
      name: "Over All",
      data: [20, 38, 26, 26, 25, 28, 32],
    },
  ];

  // Configuration options for the column chart
  const chartOptions3: ApexOptions = {
    chart: {
      type: "bar",
      height: 300,
      toolbar: {
        show: false,
        export: {
          svg: {
            filename: downloadChartName
          }
        }
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        }
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "34%",
        borderRadius: 4, // Set the border radius for rounded corners
        colors: {},
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 6,
      colors: ["transparent"],
    },
    legend: {
      show: false
    },
    xaxis: {
      labels: {
        style: {
          colors: "#7F8C8D",
        },
      },
      categories: [
        "Venue",
        "Food & Beverage",
        "Entertainment",
        "Gift Hampers",
        "AV equipment",
        "Guest Speakers",
        "Other"
      ],
    },
    yaxis: {
      labels: {
        style: {
          colors: "#7F8C8D",
        },
        formatter: function (val: number) {
          return "$" + val + "k";
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      //   y: {
      //     formatter: function (val: number) {
      //       return "$ " + val + " thousands";
      //     },
      //   },
      enabled: false,
    },
    colors: ["#1E0AF5", "#F04438", "#F79009", "#17B26A"],
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          ref={chartRef}
          options={chartOptions3}
          series={series}
          type="bar" // Set the type of chart to column (bar)
          height={300} // Set the height of the chart
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default ColumnBarChart;
